import request from '@u/request'

// 关键词列表
export function list_keywords(data) {
  return request({
    url: '/cms_shengya/list_keywords',
    method: 'POST',
    data: data || {}
  })
}
// 关键词添加
export function add_keywords(data) {
  return request({
    url: '/cms_shengya/add_keywords',
    method: 'POST',
    data: data || {}
  })
}
// 关键词修改
export function update_keywords(data) {
  return request({
    url: '/cms_shengya/update_keywords',
    method: 'POST',
    data: data || {}
  })
}
// 关键词删除
export function remove_keywords(data) {
  return request({
    url: '/cms_shengya/remove_keywords',
    method: 'POST',
    data: data || {}
  })
}

// 活动列表
export function list_activity(data) {
  return request({
    url: '/cms_shengya/list_activity',
    method: 'POST',
    data: data || {}
  })
}
// 活动添加
export function add_activity(data) {
  return request({
    url: '/cms_shengya/add_activity',
    method: 'POST',
    data: data || {}
  })
}
// 活动修改
export function update_activity(data) {
  return request({
    url: '/cms_shengya/update_activity',
    method: 'POST',
    data: data || {}
  })
}
// 活动删除
export function remove_activity(data) {
  return request({
    url: '/cms_shengya/remove_activity',
    method: 'POST',
    data: data || {}
  })
}

// 海报列表
export function poster_list(data) {
  return request({
    url: '/cms_poster/list',
    method: 'POST',
    data: data || {}
  })
}
// 获取海报内容
export function poster_get(data) {
  return request({
    url: '/cms_poster/get',
    method: 'POST',
    data: data || {}
  })
}
// 添加海报
export function poster_add(data) {
  return request({
    url: '/cms_poster/add',
    method: 'POST',
    data: data || {}
  })
}
// 更新海报
export function poster_update(data) {
  return request({
    url: '/cms_poster/update',
    method: 'POST',
    data: data || {}
  })
}
// 预览海报
export function poster_preview(data) {
  return request({
    url: '/cms_poster/preview',
    method: 'POST',
    data: data || {}
  })
}
// 删除海报
export function poster_remove(data) {
  return request({
    url: '/cms_poster/remove',
    method: 'POST',
    data: data || {}
  })
}
// 所有活动
export function all_activity(data) {
  return request({
    url: '/cms_shengya/all_activity',
    method: 'POST',
    data: data || {}
  })
}
